import { useConsentActions } from "../../hooks/use-consent-actions.js";
import { CaptureConsentDocument } from "./CaptureConsentDocument.js";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Body2, ConditionalComponent, ProgressBar, Stack, Subtitle2, useDisableBackButton } from "@myphx-engineering/phx-design-system";
import { jsx, jsxs } from "react/jsx-runtime";

//#region src/client/components/capture-consents/CaptureConsents.tsx
const CaptureConsents = ({ groupedConsents, config }) => {
	const { onComplete, onError, InfoScreen, ...consentActionConfig } = config;
	const { t } = useTranslation("cons");
	const { batchUpdateConsents } = useConsentActions(consentActionConfig);
	const [currentGroupIndex, setCurrentGroupIndex] = useState(0);
	const [showInfoScreen, setShowInfoScreen] = useState(!!InfoScreen);
	const [loading, setLoading] = useState(false);
	useDisableBackButton(true);
	const totalSteps = (InfoScreen ? 1 : 0) + groupedConsents.length;
	const currentStepNumber = showInfoScreen ? 1 : currentGroupIndex + (InfoScreen ? 2 : 1);
	const showProgressBar = totalSteps > 1;
	const handleInfoScreenContinue = () => {
		setShowInfoScreen(false);
	};
	const handleInfoScreenDeclineAll = async () => {
		try {
			setLoading(true);
			await batchUpdateConsents(groupedConsents.flatMap((group) => group.documents).map((consent) => ({
				consent,
				status: "DECLINED"
			})));
			onComplete?.();
		} catch (error) {
			console.error("Error declining all consents:", error);
			onError?.();
		} finally {
			setLoading(false);
		}
	};
	return /* @__PURE__ */ jsxs(Stack, {
		gap: "lg",
		children: [/* @__PURE__ */ jsx(ConditionalComponent, {
			condition: showProgressBar,
			children: /* @__PURE__ */ jsx(ProgressBar, {
				min: 0,
				value: currentStepNumber,
				max: totalSteps,
				showMinMaxLabels: false,
				startLabel: /* @__PURE__ */ jsx(Subtitle2, {
					bold: true,
					children: t("consents.capture.progressBarTitle")
				}),
				endLabel: /* @__PURE__ */ jsx(Body2, { children: `${currentStepNumber}/${totalSteps}` })
			})
		}), showInfoScreen && InfoScreen ? /* @__PURE__ */ jsx(InfoScreen, {
			onContinue: handleInfoScreenContinue,
			onDeclineAll: handleInfoScreenDeclineAll,
			loading
		}) : /* @__PURE__ */ jsx(CaptureConsentDocument, {
			currentGroupIndex,
			setCurrentGroupIndex,
			groupedConsents,
			config: consentActionConfig,
			loading,
			setLoading
		})]
	});
};

//#endregion
export { CaptureConsents };